// extracted by mini-css-extract-plugin
module.exports = {"card":"Statements_card__48vAo"};